import { useCallback } from 'react';
import { usePreferences } from '../contexts/PreferencesContext';
import { RAIL, defaultModeFor, isValidMode, nextMode } from '../utils/sidebarLayout';

/**
 * Sidebar mode, from the user's shell document (S4b; docs/audits/PILOT-QUOTES-SHELL.md §5,
 * DECISION 7).
 *
 * The mode is `shell.sidebarMode`. With none set it is the default for this viewport (rail
 * below the tablet threshold, expanded above: Decision 2) — computed, never written.
 * toggle() writes the new mode to the document (debounced, through usePreferences); nothing
 * but a user action changes it, and there is no resize listener. The old device key
 * (crm.ui.sidebar.v1) is not read: the preference follows the login, never the device.
 */
export const useSidebarMode = () => {
  const { doc, update } = usePreferences('shell');
  const mode = isValidMode(doc.sidebarMode)
    ? doc.sidebarMode
    : defaultModeFor(typeof window !== 'undefined' ? window.innerWidth : Infinity);

  const toggle = useCallback(() => {
    // The target is fixed at the tap, so a 409 re-applies "set rail", not "flip again".
    const target = nextMode(mode);
    update((d) => ({ ...d, sidebarMode: target }));
  }, [mode, update]);

  return { mode, toggle, isRail: mode === RAIL };
};
